import styled from 'styled-components';

// --- SHARED PAGE STYLES ---
export const PageTitle = styled.h1`
  color: ${({ theme }) => theme.heading};
  margin-bottom: 30px;

  @media (max-width: 768px) {
    font-size: 28px; /* <-- Make title smaller on mobile */
  }
`;

// --- SHARED TABLE STYLES ---
export const DocumentTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: ${({ theme }) => theme.text};
`;

export const TableHead = styled.thead`
  text-align: left;
  color: ${({ theme }) => theme.text};
  th {
    padding-bottom: 15px;
    border-bottom: 1px solid ${({ theme }) => theme.cardBorder};
  }
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.cardBorder};
  &:last-child {
    border-bottom: none;
  }
`;

export const TableCell = styled.td`
  padding: 15px 5px;
  vertical-align: middle;
`;

export const ViewLink = styled.a`
  color: ${({ theme }) => theme.primary};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const ActionButton = styled.button`
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  margin-left: 10px;
  min-width: 80px;

  &.approve {
    background-color: #34c759;
    color: white;
  }
  &.reject {
    background-color: #ff3b30;
    color: white;
  }
`;

export const ViewToggle = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`;

export const ToggleButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid ${({ theme, active }) => (active ? theme.primary : theme.cardBorder)};
  background-color: ${({ theme, active }) => (active ? theme.primary : 'transparent')};
  color: ${({ theme, active }) => (active ? 'white' : theme.text)};
  transition: all 0.2s ease-in-out;
`;